import { makeStyles } from '@mui/styles';
const sectionAccordionTitleStyles = makeStyles(() => ({
    headerLeftTitle: {
        fontWeight: 'bold',
    },
    headerRightTitle: {
        fontWeight: 'bold',
        marginRight: '32px',
    },
}), { name: 'Common_SectionAccordionTitle' });
export default sectionAccordionTitleStyles;
//# sourceMappingURL=sectionAccordionTitle.styles.js.map